import React, { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { createDepartment, updateDepartment } from '../services/departmentService';

const DepartmentForm = ({ onClose, department = null, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: department?.name || ''
  });
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('success');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate name field
    if (!formData.name.trim()) {
      setAlertMessage('Department name is required');
      setAlertVariant('danger');
      setShowAlert(true);
      return;
    }

    try {
      if (department) {
        await updateDepartment(department.id, formData);
        setAlertMessage('Department updated successfully');
        setAlertVariant('success');
        setShowAlert(true);
        onSubmit();
      } else {
        const response = await createDepartment(formData);
        setAlertMessage('Department created successfully');
        setAlertVariant('success');
        setShowAlert(true);
        onSubmit();
      }
    } catch (error) {
      setAlertMessage(error.response?.data?.message || 'An error occurred');
      setAlertVariant('danger');
      setShowAlert(true);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };



  return (
    <Modal show={true} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{department ? 'Edit Department' : 'Add New Department'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showAlert && (
          <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
            {alertMessage}
          </Alert>
        )}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              isInvalid={!formData.name.trim()}
            />
            <Form.Control.Feedback type="invalid">
              Department name is required
            </Form.Control.Feedback>
          </Form.Group>

        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" type="submit" onClick={handleSubmit}>
          {department ? 'Update' : 'Create'}
        </Button>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DepartmentForm;
